import { render, staticRenderFns } from "./StatementText.vue?vue&type=template&id=c8adc3ea&scoped=true&"
import script from "./StatementText.vue?vue&type=script&lang=js&"
export * from "./StatementText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8adc3ea",
  null
  
)

export default component.exports